import { render, staticRenderFns } from "./TemplateCard.vue?vue&type=template&id=066cdc50&scoped=true"
import script from "./TemplateCard.vue?vue&type=script&lang=js"
export * from "./TemplateCard.vue?vue&type=script&lang=js"
import style0 from "./TemplateCard.vue?vue&type=style&index=0&id=066cdc50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066cdc50",
  null
  
)

export default component.exports